import { Injectable, EventEmitter } from '@angular/core';
import { PointService } from './point.service';

@Injectable()
export class SystemService {
    public showModal: boolean = false;
    public showModalEventEmitter = new EventEmitter();

    constructor(
        private pointService: PointService
    ) {
    }

    set(show: any) {
        this.showModal = show;
        this.pointService.set(false);
        this.showModalEventEmitter.emit(show);
    }

    get() {
        return this.showModal;
    }

}



// WEBPACK FOOTER //
// ./src/services/system.service.ts